export const GET_AUTHORIZATIONS_REQUEST = 'GET_AUTHORIZATIONS_REQUEST';
export const GET_AUTHORIZATIONS_SUCCESS = 'GET_AUTHORIZATIONS_SUCCESS';
export const GET_AUTHORIZATIONS_FAILURE = 'GET_AUTHORIZATIONS_FAILURE';

export const GET_PENDING_AUTHS_REQUEST = 'GET_PENDING_AUTHS_REQUEST';
export const GET_PENDING_AUTHS_SUCCESS = 'GET_PENDING_AUTHS_SUCCESS';
export const GET_PENDING_AUTHS_FAILURE = 'GET_PENDING_AUTHS_FAILURE';

export const GET_AUTH_SUMMARY_REQUEST = 'GET_AUTH_SUMMARY_REQUEST';
export const GET_AUTH_SUMMARY_SUCCESS = 'GET_AUTH_SUMMARY_SUCCESS';
export const GET_AUTH_SUMMARY_FAILURE = 'GET_AUTH_SUMMARY_FAILURE';

export const POST_AUTHORIZATIONS_REQUEST = 'POST_AUTHORIZATIONS_REQUEST';
export const POST_AUTHORIZATIONS_SUCCESS = 'POST_AUTHORIZATIONS_SUCCESS';
export const POST_AUTHORIZATIONS_FAILURE = 'POST_AUTHORIZATIONS_FAILURE';

export const UPDATE_AUTHORIZATIONS_REQUEST = 'UPDATE_AUTHORIZATIONS_REQUEST';
export const UPDATE_AUTHORIZATIONS_SUCCESS = 'UPDATE_AUTHORIZATIONS_SUCCESS';
export const UPDATE_AUTHORIZATIONS_FAILURE = 'UPDATE_AUTHORIZATIONS_FAILURE';

export const DELETE_AUTHORIZATIONS_REQUEST = 'DELETE_AUTHORIZATIONS_REQUEST';
export const DELETE_AUTHORIZATIONS_SUCCESS = 'DELETE_AUTHORIZATIONS_SUCCESS';
export const DELETE_AUTHORIZATIONS_FAILURE = 'DELETE_AUTHORIZATIONS_FAILURE';

export const GET_EMPLOYEE_INFO_FAILURE = 'GET_EMPLOYEE_INFO_FAILURE';
export const GET_EMPLOYEE_INFO_REQUEST = 'GET_EMPLOYEE_INFO_REQUEST';
export const GET_EMPLOYEE_INFO_SUCCESS = 'GET_EMPLOYEE_INFO_SUCCESS';

export const POST_EMPLOYEE_INFO_FAILURE = 'POST_EMPLOYEE_INFO_FAILURE';
export const POST_EMPLOYEE_INFO_REQUEST = 'POST_EMPLOYEE_INFO_REQUEST';
export const POST_EMPLOYEE_INFO_SUCCESS = 'POST_EMPLOYEE_INFO_SUCCESS';

export const UPDATE_EMPLOYEE_INFO_FAILURE = 'UPDATE_EMPLOYEE_INFO_FAILURE';
export const UPDATE_EMPLOYEE_INFO_REQUEST = 'UPDATE_EMPLOYEE_INFO_REQUEST';
export const UPDATE_EMPLOYEE_INFO_SUCCESS = 'UPDATE_EMPLOYEE_INFO_SUCCESS';

export const GET_SO_INFO_FAILURE = 'GET_SO_INFO_FAILURE';
export const GET_SO_INFO_REQUEST = 'GET_SO_INFO_REQUEST';
export const GET_SO_INFO_SUCCESS = 'GET_SO_INFO_SUCCESS';

export const POST_SO_INFO_FAILURE = 'POST_SO_INFO_FAILURE';
export const POST_SO_INFO_REQUEST = 'POST_SO_INFO_REQUEST';
export const POST_SO_INFO_SUCCESS = 'POST_SO_INFO_SUCCESS';

export const UPDATE_SO_INFO_FAILURE = 'UPDATE_SO_INFO_FAILURE';
export const UPDATE_SO_INFO_REQUEST = 'UPDATE_SO_INFO_REQUEST';
export const UPDATE_SO_INFO_SUCCESS = 'UPDATE_SO_INFO_SUCCESS';

export const GET_COMMUNICATION_INFO_FAILURE = 'GET_COMMUNICATION_INFO_FAILURE';
export const GET_COMMUNICATION_INFO_REQUEST = 'GET_COMMUNICATION_INFO_REQUEST';
export const GET_COMMUNICATION_INFO_SUCCESS = 'GET_COMMUNICATION_INFO_SUCCESS';

export const POST_COMMUNICATION_INFO_FAILURE = 'POST_COMMUNICATION_INFO_FAILURE';
export const POST_COMMUNICATION_INFO_REQUEST = 'POST_COMMUNICATION_INFO_REQUEST';
export const POST_COMMUNICATION_INFO_SUCCESS = 'POST_COMMUNICATION_INFO_SUCCESS';

export const UPDATE_COMMUNICATION_INFO_FAILURE = 'UPDATE_COMMUNICATION_INFO_FAILURE';
export const UPDATE_COMMUNICATION_INFO_REQUEST = 'UPDATE_COMMUNICATION_INFO_REQUEST';
export const UPDATE_COMMUNICATION_INFO_SUCCESS = 'UPDATE_COMMUNICATION_INFO_SUCCESS';

export const SET_AUTH_ID = 'SET_AUTH_ID';
export const SET_LOADING_COMPLETE = 'SET_LOADING_COMPLETE';

export const GET_AUTH_DATE_SUMMARY_FAILURE = 'GET_AUTH_DATE_SUMMARY_FAILURE';
export const GET_AUTH_DATE_SUMMARY_REQUEST = 'GET_AUTH_DATE_SUMMARY_REQUEST';
export const GET_AUTH_DATE_SUMMARY_SUCCESS = 'GET_AUTH_DATE_SUMMARY_SUCCESS';

export const POST_AUTH_DATE_SUMMARY_FAILURE = 'POST_AUTH_DATE_SUMMARY_FAILURE';
export const POST_AUTH_DATE_SUMMARY_REQUEST = 'POST_AUTH_DATE_SUMMARY_REQUEST';
export const POST_AUTH_DATE_SUMMARY_SUCCESS = 'POST_AUTH_DATE_SUMMARY_SUCCESS';

export const UPDATE_AUTH_DATE_SUMMARY_FAILURE = 'UPDATE_AUTH_DATE_SUMMARY_FAILURE';
export const UPDATE_AUTH_DATE_SUMMARY_REQUEST = 'UPDATE_AUTH_DATE_SUMMARY_REQUEST';
export const UPDATE_AUTH_DATE_SUMMARY_SUCCESS = 'UPDATE_AUTH_DATE_SUMMARY_SUCCESS';

export const GET_DEPARTURE_ADDRESS_FAILURE = 'GET_DEPARTURE_ADDRESS_FAILURE';
export const GET_DEPARTURE_ADDRESS_REQUEST = 'GET_DEPARTURE_ADDRESS_REQUEST';
export const GET_DEPARTURE_ADDRESS_SUCCESS = 'GET_DEPARTURE_ADDRESS_SUCCESS';

export const POST_DEPARTURE_ADDRESS_FAILURE = 'POST_DEPARTURE_ADDRESS_FAILURE';
export const POST_DEPARTURE_ADDRESS_REQUEST = 'POST_DEPARTURE_ADDRESS_REQUEST';
export const POST_DEPARTURE_ADDRESS_SUCCESS = 'POST_DEPARTURE_ADDRESS_SUCCESS';

export const UPDATE_DEPARTURE_ADDRESS_FAILURE = 'UPDATE_DEPARTURE_ADDRESS_FAILURE';
export const UPDATE_DEPARTURE_ADDRESS_REQUEST = 'UPDATE_DEPARTURE_ADDRESS_REQUEST';
export const UPDATE_DEPARTURE_ADDRESS_SUCCESS = 'UPDATE_DEPARTURE_ADDRESS_SUCCESS';

export const GET_DESTINATION_ADDRESS_FAILURE = 'GET_DESTINATION_ADDRESS_FAILURE';
export const GET_DESTINATION_ADDRESS_REQUEST = 'GET_DESTINATION_ADDRESS_REQUEST';
export const GET_DESTINATION_ADDRESS_SUCCESS = 'GET_DESTINATION_ADDRESS_SUCCESS';

export const POST_DESTINATION_ADDRESS_FAILURE = 'POST_DESTINATION_ADDRESS_FAILURE';
export const POST_DESTINATION_ADDRESS_REQUEST = 'POST_DESTINATION_ADDRESS_REQUEST';
export const POST_DESTINATION_ADDRESS_SUCCESS = 'POST_DESTINATION_ADDRESS_SUCCESS';

export const UPDATE_DESTINATION_ADDRESS_FAILURE = 'UPDATE_DESTINATION_ADDRESS_FAILURE';
export const UPDATE_DESTINATION_ADDRESS_REQUEST = 'UPDATE_DESTINATION_ADDRESS_REQUEST';
export const UPDATE_DESTINATION_ADDRESS_SUCCESS = 'UPDATE_DESTINATION_ADDRESS_SUCCESS';

export const GET_AUTH_CLIENT_POLICIES_FAILURE = 'GET_AUTH_CLIENT_POLICIES_FAILURE';
export const GET_AUTH_CLIENT_POLICIES_REQUEST = 'GET_AUTH_CLIENT_POLICIES_REQUEST';
export const GET_AUTH_CLIENT_POLICIES_SUCCESS = 'GET_AUTH_CLIENT_POLICIES_SUCCESS';

export const POST_AUTH_CLIENT_POLICIES_FAILURE = 'POST_AUTH_CLIENT_POLICIES_FAILURE';
export const POST_AUTH_CLIENT_POLICIES_REQUEST = 'POST_AUTH_CLIENT_POLICIES_REQUEST';
export const POST_AUTH_CLIENT_POLICIES_SUCCESS = 'POST_AUTH_CLIENT_POLICIES_SUCCESS';

export const UPDATE_AUTH_CLIENT_POLICIES_FAILURE = 'UPDATE_AUTH_CLIENT_POLICIES_FAILURE';
export const UPDATE_AUTH_CLIENT_POLICIES_REQUEST = 'UPDATE_AUTH_CLIENT_POLICIES_REQUEST';
export const UPDATE_AUTH_CLIENT_POLICIES_SUCCESS = 'UPDATE_AUTH_CLIENT_POLICIES_SUCCESS';

export const GET_AUTH_TEAM_FAILURE = 'GET_AUTH_TEAM_FAILURE';
export const GET_AUTH_TEAM_REQUEST = 'GET_AUTH_TEAM_REQUEST';
export const GET_AUTH_TEAM_SUCCESS = 'GET_AUTH_TEAM_SUCCESS';

export const POST_AUTH_TEAM_FAILURE = 'POST_AUTH_TEAM_FAILURE';
export const POST_AUTH_TEAM_REQUEST = 'POST_AUTH_TEAM_REQUEST';
export const POST_AUTH_TEAM_SUCCESS = 'POST_AUTH_TEAM_SUCCESS';

export const UPDATE_AUTH_TEAM_FAILURE = 'UPDATE_AUTH_TEAM_FAILURE';
export const UPDATE_AUTH_TEAM_REQUEST = 'UPDATE_AUTH_TEAM_REQUEST';
export const UPDATE_AUTH_TEAM_SUCCESS = 'UPDATE_AUTH_TEAM_SUCCESS';

export const GET_ALL_AUTH_SERVICES_FAILURE = 'GET_ALL_AUTH_SERVICES_FAILURE';
export const GET_ALL_AUTH_SERVICES_REQUEST = 'GET_ALL_AUTH_SERVICES_REQUEST';
export const GET_ALL_AUTH_SERVICES_SUCCESS = 'GET_ALL_AUTH_SERVICES_SUCCESS';

export const GET_AUTH_SERVICES_FAILURE = 'GET_AUTH_SERVICES_FAILURE';
export const GET_AUTH_SERVICES_REQUEST = 'GET_AUTH_SERVICES_REQUEST';
export const GET_AUTH_SERVICES_SUCCESS = 'GET_AUTH_SERVICES_SUCCESS';

export const POST_AUTH_SERVICES_FAILURE = 'POST_AUTH_SERVICES_FAILURE';
export const POST_AUTH_SERVICES_REQUEST = 'POST_AUTH_SERVICES_REQUEST';
export const POST_AUTH_SERVICES_SUCCESS = 'POST_AUTH_SERVICES_SUCCESS';

export const UPDATE_AUTH_SERVICES_FAILURE = 'UPDATE_AUTH_SERVICES_FAILURE';
export const UPDATE_AUTH_SERVICES_REQUEST = 'UPDATE_AUTH_SERVICES_REQUEST';
export const UPDATE_AUTH_SERVICES_SUCCESS = 'UPDATE_AUTH_SERVICES_SUCCESS';

export const DELETE_AUTH_SERVICES_REQUEST = 'DELETE_AUTH_SERVICES_REQUEST';
export const DELETE_AUTH_SERVICES_SUCCESS = 'DELETE_AUTH_SERVICES_SUCCESS';
export const DELETE_AUTH_SERVICES_FAILURE = 'DELETE_AUTH_SERVICES_FAILURE';

export const GET_AUTH_LIST_CLIENT_POLICIES_BY_CLIENT_FAILURE = 'GET_AUTH_LIST_CLIENT_POLICIES_BY_CLIENT_FAILURE';
export const GET_AUTH_LIST_CLIENT_POLICIES_BY_CLIENT_REQUEST = 'GET_AUTH_LIST_CLIENT_POLICIES_BY_CLIENT_REQUEST';
export const GET_AUTH_LIST_CLIENT_POLICIES_BY_CLIENT_SUCCESS = 'GET_AUTH_LIST_CLIENT_POLICIES_BY_CLIENT_SUCCESS';

export const GET_AUTH_LIST_CLIENT_POLICIES_FAILURE = 'GET_AUTH_LIST_CLIENT_POLICIES_FAILURE';
export const GET_AUTH_LIST_CLIENT_POLICIES_REQUEST = 'GET_AUTH_LIST_CLIENT_POLICIES_REQUEST';
export const GET_AUTH_LIST_CLIENT_POLICIES_SUCCESS = 'GET_AUTH_LIST_CLIENT_POLICIES_SUCCESS';

export const POST_AUTH_LIST_CLIENT_POLICIES_FAILURE = 'POST_AUTH_LIST_CLIENT_POLICIES_FAILURE';
export const POST_AUTH_LIST_CLIENT_POLICIES_REQUEST = 'POST_AUTH_LIST_CLIENT_POLICIES_REQUEST';
export const POST_AUTH_LIST_CLIENT_POLICIES_SUCCESS = 'POST_AUTH_LIST_CLIENT_POLICIES_SUCCESS';

export const UPDATE_AUTH_LIST_CLIENT_POLICIES_FAILURE = 'UPDATE_AUTH_LIST_CLIENT_POLICIES_FAILURE';
export const UPDATE_AUTH_LIST_CLIENT_POLICIES_REQUEST = 'UPDATE_AUTH_LIST_CLIENT_POLICIES_REQUEST';
export const UPDATE_AUTH_LIST_CLIENT_POLICIES_SUCCESS = 'UPDATE_AUTH_LIST_CLIENT_POLICIES_SUCCESS';

export const DELETE_AUTH_LIST_CLIENT_POLICIES_FAILURE = 'DELETE_AUTH_LIST_CLIENT_POLICIES_FAILURE';
export const DELETE_AUTH_LIST_CLIENT_POLICIES_REQUEST = 'DELETE_AUTH_LIST_CLIENT_POLICIES_REQUEST';
export const DELETE_AUTH_LIST_CLIENT_POLICIES_SUCCESS = 'DELETE_AUTH_LIST_CLIENT_POLICIES_SUCCESS';

export const GET_ACTIVITY_LOG_FAILURE = 'GET_ACTIVITY_LOG_FAILURE';
export const GET_ACTIVITY_LOG_REQUEST = 'GET_ACTIVITY_LOG_REQUEST';
export const GET_ACTIVITY_LOG_SUCCESS = 'GET_ACTIVITY_LOG_SUCCESS';

export const GET_TAX_POLICIES_FAILURE = 'GET_TAX_POLICIES_FAILURE';
export const GET_TAX_POLICIES_REQUEST = 'GET_TAX_POLICIES_REQUEST';
export const GET_TAX_POLICIES_SUCCESS = 'GET_TAX_POLICIES_SUCCESS';

export const GET_TAX_POLICIES_BY_CLIENT_FAILURE = 'GET_TAX_POLICIES_BY_CLIENT_FAILURE';
export const GET_TAX_POLICIES_BY_CLIENT_REQUEST = 'GET_TAX_POLICIES_BY_CLIENT_REQUEST';
export const GET_TAX_POLICIES_BY_CLIENT_SUCCESS = 'GET_TAX_POLICIES_BY_CLIENT_SUCCESS';

export const POST_TAX_POLICY_FAILURE = 'POST_TAX_POLICY_FAILURE';
export const POST_TAX_POLICY_REQUEST = 'POST_TAX_POLICY_REQUEST';
export const POST_TAX_POLICY_SUCCESS = 'POST_TAX_POLICY_SUCCESS';

export const UPDATE_TAX_POLICY_FAILURE = 'UPDATE_TAX_POLICY_FAILURE';
export const UPDATE_TAX_POLICY_REQUEST = 'UPDATE_TAX_POLICY_REQUEST';
export const UPDATE_TAX_POLICY_SUCCESS = 'UPDATE_TAX_POLICY_SUCCESS';

export const DELETE_TAX_POLICY_FAILURE = 'DELETE_TAX_POLICY_FAILURE';
export const DELETE_TAX_POLICY_REQUEST = 'DELETE_TAX_POLICY_REQUEST';
export const DELETE_TAX_POLICY_SUCCESS = 'DELETE_TAX_POLICY_SUCCESS';

export const GET_AUTH_TAX_ASSISTANCE_FAILURE = 'GET_AUTH_TAX_ASSISTANCE_FAILURE';
export const GET_AUTH_TAX_ASSISTANCE_REQUEST = 'GET_AUTH_TAX_ASSISTANCE_REQUEST';
export const GET_AUTH_TAX_ASSISTANCE_SUCCESS = 'GET_AUTH_TAX_ASSISTANCE_SUCCESS';

export const POST_AUTH_TAX_ASSISTANCE_FAILURE = 'POST_AUTH_TAX_ASSISTANCE_FAILURE';
export const POST_AUTH_TAX_ASSISTANCE_REQUEST = 'POST_AUTH_TAX_ASSISTANCE_REQUEST';
export const POST_AUTH_TAX_ASSISTANCE_SUCCESS = 'POST_AUTH_TAX_ASSISTANCE_SUCCESS';

export const UPDATE_AUTH_TAX_ASSISTANCE_FAILURE = 'UPDATE_AUTH_TAX_ASSISTANCE_FAILURE';
export const UPDATE_AUTH_TAX_ASSISTANCE_REQUEST = 'UPDATE_AUTH_TAX_ASSISTANCE_REQUEST';
export const UPDATE_AUTH_TAX_ASSISTANCE_SUCCESS = 'UPDATE_AUTH_TAX_ASSISTANCE_SUCCESS';

export const GET_USER_SETTINGS_FAILURE = 'GET_USER_SETTINGS_FAILURE';
export const GET_USER_SETTINGS_REQUEST = 'GET_USER_SETTINGS_REQUEST';
export const GET_USER_SETTINGS_SUCCESS = 'GET_USER_SETTINGS_SUCCESS';

export const POST_USER_SETTINGS_FAILURE = 'POST_USER_SETTINGS_FAILURE';
export const POST_USER_SETTINGS_REQUEST = 'POST_USER_SETTINGS_REQUEST';
export const POST_USER_SETTINGS_SUCCESS = 'POST_USER_SETTINGS_SUCCESS';

export const UPDATE_USER_SETTINGS_FAILURE = 'UPDATE_USER_SETTINGS_FAILURE';
export const UPDATE_USER_SETTINGS_REQUEST = 'UPDATE_USER_SETTINGS_REQUEST';
export const UPDATE_USER_SETTINGS_SUCCESS = 'UPDATE_USER_SETTINGS_SUCCESS';

export const GET_AUTH_DESTINATION_SERVICES_FAILURE = 'GET_AUTH_DESTINATION_SERVICES_FAILURE';
export const GET_AUTH_DESTINATION_SERVICES_REQUEST = 'GET_AUTH_DESTINATION_SERVICES_REQUEST';
export const GET_AUTH_DESTINATION_SERVICES_SUCCESS = 'GET_AUTH_DESTINATION_SERVICES_SUCCESS';

export const POST_AUTH_DESTINATION_SERVICES_FAILURE = 'POST_AUTH_DESTINATION_SERVICES_FAILURE';
export const POST_AUTH_DESTINATION_SERVICES_REQUEST = 'POST_AUTH_DESTINATION_SERVICES_REQUEST';
export const POST_AUTH_DESTINATION_SERVICES_SUCCESS = 'POST_AUTH_DESTINATION_SERVICES_SUCCESS';

export const UPDATE_AUTH_DESTINATION_SERVICES_FAILURE = 'UPDATE_AUTH_DESTINATION_SERVICES_FAILURE';
export const UPDATE_AUTH_DESTINATION_SERVICES_REQUEST = 'UPDATE_AUTH_DESTINATION_SERVICES_REQUEST';
export const UPDATE_AUTH_DESTINATION_SERVICES_SUCCESS = 'UPDATE_AUTH_DESTINATION_SERVICES_SUCCESS';

export const GET_ALL_BROKER_AGENTS_FAILURE = 'GET_ALL_BROKER_AGENTS_FAILURE';
export const GET_ALL_BROKER_AGENTS_REQUEST = 'GET_ALL_BROKER_AGENTS_REQUEST';
export const GET_ALL_BROKER_AGENTS_SUCCESS = 'GET_ALL_BROKER_AGENTS_SUCCESS';

export const GET_BROKER_AGENTS_BY_ID_FAILURE = 'GET_BROKER_AGENTS_BY_ID_FAILURE';
export const GET_BROKER_AGENTS_BY_ID_REQUEST = 'GET_BROKER_AGENTS_BY_ID_REQUEST';
export const GET_BROKER_AGENTS_BY_ID_SUCCESS = 'GET_BROKER_AGENTS_BY_ID_SUCCESS';

export const POST_BROKER_AGENTS_FAILURE = 'POST_BROKER_AGENTS_FAILURE';
export const POST_BROKER_AGENTS_REQUEST = 'POST_BROKER_AGENTS_REQUEST';
export const POST_BROKER_AGENTS_SUCCESS = 'POST_BROKER_AGENTS_SUCCESS';

export const UPDATE_BROKER_AGENTS_FAILURE = 'UPDATE_BROKER_AGENTS_FAILURE';
export const UPDATE_BROKER_AGENTS_REQUEST = 'UPDATE_BROKER_AGENTS_REQUEST';
export const UPDATE_BROKER_AGENTS_SUCCESS = 'UPDATE_BROKER_AGENTS_SUCCESS';

export const DELETE_BROKER_AGENTS_FAILURE = 'DELETE_BROKER_AGENTS_FAILURE';
export const DELETE_BROKER_AGENTS_REQUEST = 'DELETE_BROKER_AGENTS_REQUEST';
export const DELETE_BROKER_AGENTS_SUCCESS = 'DELETE_BROKER_AGENTS_SUCCESS';

export const GET_AUTH_HOUSE_HUNTING_LIST_FAILURE = 'GET_AUTH_HOUSE_HUNTING_LIST_FAILURE';
export const GET_AUTH_HOUSE_HUNTING_LIST_REQUEST = 'GET_AUTH_HOUSE_HUNTING_LIST_REQUEST';
export const GET_AUTH_HOUSE_HUNTING_LIST_SUCCESS = 'GET_AUTH_HOUSE_HUNTING_LIST_SUCCESS';

export const POST_AUTH_HOUSE_HUNTING_LIST_FAILURE = 'POST_AUTH_HOUSE_HUNTING_LIST_FAILURE';
export const POST_AUTH_HOUSE_HUNTING_LIST_REQUEST = 'POST_AUTH_HOUSE_HUNTING_LIST_REQUEST';
export const POST_AUTH_HOUSE_HUNTING_LIST_SUCCESS = 'POST_AUTH_HOUSE_HUNTING_LIST_SUCCESS';

export const UPDATE_AUTH_HOUSE_HUNTING_LIST_FAILURE = 'UPDATE_AUTH_HOUSE_HUNTING_LIST_FAILURE';
export const UPDATE_AUTH_HOUSE_HUNTING_LIST_REQUEST = 'UPDATE_AUTH_HOUSE_HUNTING_LIST_REQUEST';
export const UPDATE_AUTH_HOUSE_HUNTING_LIST_SUCCESS = 'UPDATE_AUTH_HOUSE_HUNTING_LIST_SUCCESS';

export const DELETE_AUTH_HOUSE_HUNTING_LIST_FAILURE = 'DELETE_AUTH_HOUSE_HUNTING_LIST_FAILURE';
export const DELETE_AUTH_HOUSE_HUNTING_LIST_REQUEST = 'DELETE_AUTH_HOUSE_HUNTING_LIST_REQUEST';
export const DELETE_AUTH_HOUSE_HUNTING_LIST_SUCCESS = 'DELETE_AUTH_HOUSE_HUNTING_LIST_SUCCESS';

export const GET_AUTH_OFFER_HISTORY_LIST_FAILURE = 'GET_AUTH_OFFER_HISTORY_LIST_FAILURE';
export const GET_AUTH_OFFER_HISTORY_LIST_REQUEST = 'GET_AUTH_OFFER_HISTORY_LIST_REQUEST';
export const GET_AUTH_OFFER_HISTORY_LIST_SUCCESS = 'GET_AUTH_OFFER_HISTORY_LIST_SUCCESS';

export const POST_AUTH_OFFER_HISTORY_LIST_FAILURE = 'POST_AUTH_OFFER_HISTORY_LIST_FAILURE';
export const POST_AUTH_OFFER_HISTORY_LIST_REQUEST = 'POST_AUTH_OFFER_HISTORY_LIST_REQUEST';
export const POST_AUTH_OFFER_HISTORY_LIST_SUCCESS = 'POST_AUTH_OFFER_HISTORY_LIST_SUCCESS';

export const UPDATE_AUTH_OFFER_HISTORY_LIST_FAILURE = 'UPDATE_AUTH_OFFER_HISTORY_LIST_FAILURE';
export const UPDATE_AUTH_OFFER_HISTORY_LIST_REQUEST = 'UPDATE_AUTH_OFFER_HISTORY_LIST_REQUEST';
export const UPDATE_AUTH_OFFER_HISTORY_LIST_SUCCESS = 'UPDATE_AUTH_OFFER_HISTORY_LIST_SUCCESS';

export const DELETE_AUTH_OFFER_HISTORY_LIST_FAILURE = 'DELETE_AUTH_OFFER_HISTORY_LIST_FAILURE';
export const DELETE_AUTH_OFFER_HISTORY_LIST_REQUEST = 'DELETE_AUTH_OFFER_HISTORY_LIST_REQUEST';
export const DELETE_AUTH_OFFER_HISTORY_LIST_SUCCESS = 'DELETE_AUTH_OFFER_HISTORY_LIST_SUCCESS';

export const GET_AUTH_PETS_FAILURE = 'GET_AUTH_PETS_FAILURE';
export const GET_AUTH_PETS_REQUEST = 'GET_AUTH_PETS_REQUEST';
export const GET_AUTH_PETS_SUCCESS = 'GET_AUTH_PETS_SUCCESS';

export const POST_AUTH_PETS_FAILURE = 'POST_AUTH_PETS_FAILURE';
export const POST_AUTH_PETS_REQUEST = 'POST_AUTH_PETS_REQUEST';
export const POST_AUTH_PETS_SUCCESS = 'POST_AUTH_PETS_SUCCESS';

export const GET_TEMPORARY_LIVING_ASSIGNMENT_FAILURE = 'GET_TEMPORARY_LIVING_ASSIGNMENT_FAILURE';
export const GET_TEMPORARY_LIVING_ASSIGNMENT_REQUEST = 'GET_TEMPORARY_LIVING_ASSIGNMENT_REQUEST';
export const GET_TEMPORARY_LIVING_ASSIGNMENT_SUCCESS = 'GET_TEMPORARY_LIVING_ASSIGNMENT_SUCCESS';

export const POST_TEMPORARY_LIVING_ASSIGNMENT_FAILURE = 'POST_TEMPORARY_LIVING_ASSIGNMENT_FAILURE';
export const POST_TEMPORARY_LIVING_ASSIGNMENT_REQUEST = 'POST_TEMPORARY_LIVING_ASSIGNMENT_REQUEST';
export const POST_TEMPORARY_LIVING_ASSIGNMENT_SUCCESS = 'POST_TEMPORARY_LIVING_ASSIGNMENT_SUCCESS';

export const UPDATE_TEMPORARY_LIVING_ASSIGNMENT_FAILURE = 'UPDATE_TEMPORARY_LIVING_ASSIGNMENT_FAILURE';
export const UPDATE_TEMPORARY_LIVING_ASSIGNMENT_REQUEST = 'UPDATE_TEMPORARY_LIVING_ASSIGNMENT_REQUEST';
export const UPDATE_TEMPORARY_LIVING_ASSIGNMENT_SUCCESS = 'UPDATE_TEMPORARY_LIVING_ASSIGNMENT_SUCCESS';

export const DELETE_TEMPORARY_LIVING_ASSIGNMENT_FAILURE = 'DELETE_TEMPORARY_LIVING_ASSIGNMENT_FAILURE';
export const DELETE_TEMPORARY_LIVING_ASSIGNMENT_REQUEST = 'DELETE_TEMPORARY_LIVING_ASSIGNMENT_REQUEST';
export const DELETE_TEMPORARY_LIVING_ASSIGNMENT_SUCCESS = 'DELETE_TEMPORARY_LIVING_ASSIGNMENT_SUCCESS';

export const SET_SELECTED_TEMPORARY_LIVING_ASSIGNMENT = 'SET_SELECTED_TEMPORARY_LIVING_ASSIGNMENT';

export const GET_HHG_SEGMENTS_FAILURE = 'GET_HHG_SEGMENTS_FAILURE';
export const GET_HHG_SEGMENTS_REQUEST = 'GET_HHG_SEGMENTS_REQUEST';
export const GET_HHG_SEGMENTS_SUCCESS = 'GET_HHG_SEGMENTS_SUCCESS';

export const POST_HHG_SEGMENT_FAILURE = 'POST_HHG_SEGMENT_FAILURE';
export const POST_HHG_SEGMENT_REQUEST = 'POST_HHG_SEGMENT_REQUEST';
export const POST_HHG_SEGMENT_SUCCESS = 'POST_HHG_SEGMENT_SUCCESS';

export const UPDATE_HHG_SEGMENT_FAILURE = 'UPDATE_BROKER_AGENTS_FAILURE';
export const UPDATE_HHG_SEGMENT_REQUEST = 'UPDATE_BROKER_AGENTS_REQUEST';
export const UPDATE_HHG_SEGMENT_SUCCESS = 'UPDATE_HHG_SEGMENT_SUCCESS';

export const GET_HHG_MOVING_DATE_FAILURE = 'GET_HHG_MOVING_DATE_FAILURE';
export const GET_HHG_MOVING_DATE_REQUEST = 'GET_HHG_MOVING_DATE_REQUEST';
export const GET_HHG_MOVING_DATE_SUCCESS = 'GET_HHG_MOVING_DATE_SUCCESS';

export const POST_HHG_MOVING_DATE_FAILURE = 'POST_HHG_MOVING_DATE_FAILURE';
export const POST_HHG_MOVING_DATE_REQUEST = 'POST_HHG_MOVING_DATE_REQUEST';
export const POST_HHG_MOVING_DATE_SUCCESS = 'POST_HHG_MOVING_DATE_SUCCESS';

export const UPDATE_HHG_MOVING_DATE_FAILURE = 'UPDATE_HHG_MOVING_DATE_FAILURE';
export const UPDATE_HHG_MOVING_DATE_REQUEST = 'UPDATE_HHG_MOVING_DATE_REQUEST';
export const UPDATE_HHG_MOVING_DATE_SUCCESS = 'UPDATE_HHG_MOVING_DATE_SUCCESS';

export const DELETE_HHG_MOVING_DATE_FAILURE = 'DELETE_HHG_MOVING_DATE_FAILURE';
export const DELETE_HHG_MOVING_DATE_REQUEST = 'DELETE_HHG_MOVING_DATE_REQUEST';
export const DELETE_HHG_MOVING_DATE_SUCCESS = 'DELETE_HHG_MOVING_DATE_SUCCESS';

export const GET_HHG_ITEMS_FAILURE = 'GET_HHG_ITEMS_FAILURE';
export const GET_HHG_ITEMS_REQUEST = 'GET_HHG_ITEMS_REQUEST';
export const GET_HHG_ITEMS_SUCCESS = 'GET_HHG_ITEMS_SUCCESS';

export const POST_HHG_ITEMS_FAILURE = 'POST_HHG_ITEMS_FAILURE';
export const POST_HHG_ITEMS_REQUEST = 'POST_HHG_ITEMS_REQUEST';
export const POST_HHG_ITEMS_SUCCESS = 'POST_HHG_ITEMS_SUCCESS';

export const UPDATE_HHG_ITEMS_FAILURE = 'UPDATE_HHG_ITEMS_FAILURE';
export const UPDATE_HHG_ITEMS_REQUEST = 'UPDATE_HHG_ITEMS_REQUEST';
export const UPDATE_HHG_ITEMS_SUCCESS = 'UPDATE_HHG_ITEMS_SUCCESS';

export const DELETE_HHG_ITEMS_FAILURE = 'DELETE_HHG_ITEMS_FAILURE';
export const DELETE_HHG_ITEMS_REQUEST = 'DELETE_HHG_ITEMS_REQUEST';
export const DELETE_HHG_ITEMS_SUCCESS = 'DELETE_HHG_ITEMS_SUCCESS';

export const GET_HHG_ESTIMATES_FAILURE = 'GET_HHG_ESTIMATES_FAILURE';
export const GET_HHG_ESTIMATES_REQUEST = 'GET_HHG_ESTIMATES_REQUEST';
export const GET_HHG_ESTIMATES_SUCCESS = 'GET_HHG_ESTIMATES_SUCCESS';

export const POST_HHG_ESTIMATE_FAILURE = 'POST_HHG_ESTIMATE_FAILURE';
export const POST_HHG_ESTIMATE_REQUEST = 'POST_HHG_ESTIMATE_REQUEST';
export const POST_HHG_ESTIMATE_SUCCESS = 'POST_HHG_ESTIMATE_SUCCESS';

export const UPDATE_HHG_ESTIMATE_FAILURE = 'UPDATE_HHG_ESTIMATE_FAILURE';
export const UPDATE_HHG_ESTIMATE_REQUEST = 'UPDATE_HHG_ESTIMATE_REQUEST';
export const UPDATE_HHG_ESTIMATE_SUCCESS = 'UPDATE_HHG_ESTIMATE_SUCCESS';

export const DELETE_HHG_VEHICLES_FAILURE = 'DELETE_HHG_VEHICLES_FAILURE';
export const DELETE_HHG_VEHICLES_REQUEST = 'DELETE_HHG_VEHICLES_REQUEST';
export const DELETE_HHG_VEHICLES_SUCCESS = 'DELETE_HHG_VEHICLES_SUCCESS';

export const GET_VENDORS_FAILURE = 'GET_VENDORS_FAILURE';
export const GET_VENDORS_REQUEST = 'GET_VENDORS_REQUEST';
export const GET_VENDORS_SUCCESS = 'GET_VENDORS_SUCCESS';

export const POST_VENDORS_FAILURE = 'POST_VENDORS_FAILURE';
export const POST_VENDORS_REQUEST = 'POST_VENDORS_REQUEST';
export const POST_VENDORS_SUCCESS = 'POST_VENDORS_SUCCESS';

export const UPDATE_VENDORS_FAILURE = 'UPDATE_VENDORS_FAILURE';
export const UPDATE_VENDORS_REQUEST = 'UPDATE_VENDORS_REQUEST';
export const UPDATE_VENDORS_SUCCESS = 'UPDATE_VENDORS_SUCCESS';

export const DELETE_VENDORS_FAILURE = 'DELETE_VENDORS_FAILURE';
export const DELETE_VENDORS_REQUEST = 'DELETE_VENDORS_REQUEST';
export const DELETE_VENDORS_SUCCESS = 'DELETE_VENDORS_SUCCESS';

export const GET_VENDOR_CONTACT_FAILURE = 'GET_VENDOR_CONTACT_FAILURE';
export const GET_VENDOR_CONTACT_REQUEST = 'GET_VENDOR_CONTACT_REQUEST';
export const GET_VENDOR_CONTACT_SUCCESS = 'GET_VENDOR_CONTACT_SUCCESS';

export const POST_VENDOR_CONTACT_FAILURE = 'POST_VENDOR_CONTACT_FAILURE';
export const POST_VENDOR_CONTACT_REQUEST = 'POST_VENDOR_CONTACT_REQUEST';
export const POST_VENDOR_CONTACT_SUCCESS = 'POST_VENDOR_CONTACT_SUCCESS';

export const UPDATE_VENDOR_CONTACT_FAILURE = 'UPDATE_VENDOR_CONTACT_FAILURE';
export const UPDATE_VENDOR_CONTACT_REQUEST = 'UPDATE_VENDOR_CONTACT_REQUEST';
export const UPDATE_VENDOR_CONTACT_SUCCESS = 'UPDATE_VENDOR_CONTACT_SUCCESS';

export const DELETE_VENDOR_CONTACT_FAILURE = 'DELETE_VENDOR_CONTACT_FAILURE';
export const DELETE_VENDOR_CONTACT_REQUEST = 'DELETE_VENDOR_CONTACT_REQUEST';
export const DELETE_VENDOR_CONTACT_SUCCESS = 'DELETE_VENDOR_CONTACT_SUCCESS';

export const GET_GLOBAL_INFO_FAILURE = 'GET_GLOBAL_INFO_FAILURE';
export const GET_GLOBAL_INFO_REQUEST = 'GET_GLOBAL_INFO_REQUEST';
export const GET_GLOBAL_INFO_SUCCESS = 'GET_GLOBAL_INFO_SUCCESS';

export const POST_GLOBAL_INFO_FAILURE = 'POST_GLOBAL_INFO_FAILURE';
export const POST_GLOBAL_INFO_REQUEST = 'POST_GLOBAL_INFO_REQUEST';
export const POST_GLOBAL_INFO_SUCCESS = 'POST_GLOBAL_INFO_SUCCESS';

export const UPDATE_GLOBAL_INFO_FAILURE = 'UPDATE_GLOBAL_INFO_FAILURE';
export const UPDATE_GLOBAL_INFO_REQUEST = 'UPDATE_GLOBAL_INFO_REQUEST';
export const UPDATE_GLOBAL_INFO_SUCCESS = 'UPDATE_GLOBAL_INFO_SUCCESS';

export const GET_ASSIGNMENT_TRIPS_FAILURE = 'GET_ASSIGNMENT_TRIPS_FAILURE';
export const GET_ASSIGNMENT_TRIPS_REQUEST = 'GET_ASSIGNMENT_TRIPS_REQUEST';
export const GET_ASSIGNMENT_TRIPS_SUCCESS = 'GET_ASSIGNMENT_TRIPS_SUCCESS';

export const GET_ASSIGNMENT_TRIP_FAILURE = 'GET_ASSIGNMENT_TRIP_FAILURE';
export const GET_ASSIGNMENT_TRIP_REQUEST = 'GET_ASSIGNMENT_TRIP_REQUEST';
export const GET_ASSIGNMENT_TRIP_SUCCESS = 'GET_ASSIGNMENT_TRIP_SUCCESS';

export const UPSERT_ASSIGNMENT_TRIPS_FAILURE = 'UPSERT_ASSIGNMENT_TRIPS_FAILURE';
export const UPSERT_ASSIGNMENT_TRIPS_REQUEST = 'UPSERT_ASSIGNMENT_TRIPS_REQUEST';
export const UPSERT_ASSIGNMENT_TRIPS_SUCCESS = 'UPSERT_ASSIGNMENT_TRIPS_SUCCESS';

export const DELETE_ASSIGNMENT_TRIPS_FAILURE = 'DELETE_ASSIGNMENT_TRIPS_FAILURE';
export const DELETE_ASSIGNMENT_TRIPS_REQUEST = 'DELETE_ASSIGNMENT_TRIPS_REQUEST';
export const DELETE_ASSIGNMENT_TRIPS_SUCCESS = 'DELETE_ASSIGNMENT_TRIPS_SUCCESS';

export const GET_GLOBAL_ASSIGNMENT_FAILURE = 'GET_GLOBAL_ASSIGNMENT_FAILURE';
export const GET_GLOBAL_ASSIGNMENT_REQUEST = 'GET_GLOBAL_ASSIGNMENT_REQUEST';
export const GET_GLOBAL_ASSIGNMENT_SUCCESS = 'GET_GLOBAL_ASSIGNMENT_SUCCESS';

export const GET_ASSIGNMENT_EXTENSIONS_FAILURE = 'GET_ASSIGNMENT_EXTENSIONS_FAILURE';
export const GET_ASSIGNMENT_EXTENSIONS_REQUEST = 'GET_ASSIGNMENT_EXTENSIONS_REQUEST';
export const GET_ASSIGNMENT_EXTENSIONS_SUCCESS = 'GET_ASSIGNMENT_EXTENSIONS_SUCCESS';

export const POST_ASSIGNMENT_EXTENSIONS_FAILURE = 'POST_ASSIGNMENT_EXTENSIONS_FAILURE';
export const POST_ASSIGNMENT_EXTENSIONS_REQUEST = 'POST_ASSIGNMENT_EXTENSIONS_REQUEST';
export const POST_ASSIGNMENT_EXTENSIONS_SUCCESS = 'POST_ASSIGNMENT_EXTENSIONS_SUCCESS';

export const UPDATE_ASSIGNMENT_EXTENSIONS_FAILURE = 'UPDATE_ASSIGNMENT_EXTENSIONS_FAILURE';
export const UPDATE_ASSIGNMENT_EXTENSIONS_REQUEST = 'UPDATE_ASSIGNMENT_EXTENSIONS_REQUEST';
export const UPDATE_ASSIGNMENT_EXTENSIONS_SUCCESS = 'UPDATE_ASSIGNMENT_EXTENSIONS_SUCCESS';

export const DELETE_ASSIGNMENT_EXTENSIONS_FAILURE = 'DELETE_ASSIGNMENT_EXTENSIONS_FAILURE';
export const DELETE_ASSIGNMENT_EXTENSIONS_REQUEST = 'DELETE_ASSIGNMENT_EXTENSIONS_REQUEST';
export const DELETE_ASSIGNMENT_EXTENSIONS_SUCCESS = 'DELETE_ASSIGNMENT_EXTENSIONS_SUCCESS';

export const GET_GLOBAL_DESTINATION_SERVICES_FAILURE = 'GET_GLOBAL_DESTINATION_SERVICES_FAILURE';
export const GET_GLOBAL_DESTINATION_SERVICES_REQUEST = 'GET_GLOBAL_DESTINATION_SERVICES_REQUEST';
export const GET_GLOBAL_DESTINATION_SERVICES_SUCCESS = 'GET_GLOBAL_DESTINATION_SERVICES_SUCCESS';

export const POST_GLOBAL_DESTINATION_SERVICES_FAILURE = 'POST_GLOBAL_DESTINATION_SERVICES_FAILURE';
export const POST_GLOBAL_DESTINATION_SERVICES_REQUEST = 'POST_GLOBAL_DESTINATION_SERVICES_REQUEST';
export const POST_GLOBAL_DESTINATION_SERVICES_SUCCESS = 'POST_GLOBAL_DESTINATION_SERVICES_SUCCESS';

export const UPDATE_GLOBAL_DESTINATION_SERVICES_FAILURE = 'UPDATE_GLOBAL_DESTINATION_SERVICES_FAILURE';
export const UPDATE_GLOBAL_DESTINATION_SERVICES_REQUEST = 'UPDATE_GLOBAL_DESTINATION_SERVICES_REQUEST';
export const UPDATE_GLOBAL_DESTINATION_SERVICES_SUCCESS = 'UPDATE_GLOBAL_DESTINATION_SERVICES_SUCCESS';

export const DELETE_GLOBAL_DESTINATION_SERVICES_FAILURE = 'DELETE_GLOBAL_DESTINATION_SERVICES_FAILURE';
export const DELETE_GLOBAL_DESTINATION_SERVICES_REQUEST = 'DELETE_GLOBAL_DESTINATION_SERVICES_REQUEST';
export const DELETE_GLOBAL_DESTINATION_SERVICES_SUCCESS = 'DELETE_GLOBAL_DESTINATION_SERVICES_SUCCESS';

export const GET_GLOBAL_LANGUAGE_TRAINING_FAILURE = 'GET_GLOBAL_LANGUAGE_TRAINING_FAILURE';
export const GET_GLOBAL_LANGUAGE_TRAINING_REQUEST = 'GET_GLOBAL_LANGUAGE_TRAINING_REQUEST';
export const GET_GLOBAL_LANGUAGE_TRAINING_SUCCESS = 'GET_GLOBAL_LANGUAGE_TRAINING_SUCCESS';

export const POST_GLOBAL_LANGUAGE_TRAINING_FAILURE = 'POST_GLOBAL_LANGUAGE_TRAINING_FAILURE';
export const POST_GLOBAL_LANGUAGE_TRAINING_REQUEST = 'POST_GLOBAL_LANGUAGE_TRAINING_REQUEST';
export const POST_GLOBAL_LANGUAGE_TRAINING_SUCCESS = 'POST_GLOBAL_LANGUAGE_TRAINING_SUCCESS';

export const UPDATE_GLOBAL_LANGUAGE_TRAINING_FAILURE = 'UPDATE_GLOBAL_LANGUAGE_TRAINING_FAILURE';
export const UPDATE_GLOBAL_LANGUAGE_TRAINING_REQUEST = 'UPDATE_GLOBAL_LANGUAGE_TRAINING_REQUEST';
export const UPDATE_GLOBAL_LANGUAGE_TRAINING_SUCCESS = 'UPDATE_GLOBAL_LANGUAGE_TRAINING_SUCCESS';

export const DELETE_GLOBAL_LANGUAGE_TRAINING_FAILURE = 'DELETE_GLOBAL_LANGUAGE_TRAINING_FAILURE';
export const DELETE_GLOBAL_LANGUAGE_TRAINING_REQUEST = 'DELETE_GLOBAL_LANGUAGE_TRAINING_REQUEST';
export const DELETE_GLOBAL_LANGUAGE_TRAINING_SUCCESS = 'DELETE_GLOBAL_LANGUAGE_TRAINING_SUCCESS';

export const GET_GLOBAL_INTERNATIONAL_SCHOOLING_FAILURE = 'GET_GLOBAL_INTERNATIONAL_SCHOOLING_FAILURE';
export const GET_GLOBAL_INTERNATIONAL_SCHOOLING_REQUEST = 'GET_GLOBAL_INTERNATIONAL_SCHOOLING_REQUEST';
export const GET_GLOBAL_INTERNATIONAL_SCHOOLING_SUCCESS = 'GET_GLOBAL_INTERNATIONAL_SCHOOLING_SUCCESS';

export const POST_GLOBAL_INTERNATIONAL_SCHOOLING_FAILURE = 'POST_GLOBAL_INTERNATIONAL_SCHOOLING_FAILURE';
export const POST_GLOBAL_INTERNATIONAL_SCHOOLING_REQUEST = 'POST_GLOBAL_INTERNATIONAL_SCHOOLING_REQUEST';
export const POST_GLOBAL_INTERNATIONAL_SCHOOLING_SUCCESS = 'POST_GLOBAL_INTERNATIONAL_SCHOOLING_SUCCESS';

export const UPDATE_GLOBAL_INTERNATIONAL_SCHOOLING_FAILURE = 'UPDATE_GLOBAL_INTERNATIONAL_SCHOOLING_FAILURE';
export const UPDATE_GLOBAL_INTERNATIONAL_SCHOOLING_REQUEST = 'UPDATE_GLOBAL_INTERNATIONAL_SCHOOLING_REQUEST';
export const UPDATE_GLOBAL_INTERNATIONAL_SCHOOLING_SUCCESS = 'UPDATE_GLOBAL_INTERNATIONAL_SCHOOLING_SUCCESS';

export const DELETE_GLOBAL_INTERNATIONAL_SCHOOLING_FAILURE = 'DELETE_GLOBAL_INTERNATIONAL_SCHOOLING_FAILURE';
export const DELETE_GLOBAL_INTERNATIONAL_SCHOOLING_REQUEST = 'DELETE_GLOBAL_INTERNATIONAL_SCHOOLING_REQUEST';
export const DELETE_GLOBAL_INTERNATIONAL_SCHOOLING_SUCCESS = 'DELETE_GLOBAL_INTERNATIONAL_SCHOOLING_SUCCESS';

export const GET_HOMESALE_INFO_FAILURE = 'GET_HOMESALE_INFO_FAILURE';
export const GET_HOMESALE_INFO_REQUEST = 'GET_HOMESALE_INFO_REQUEST';
export const GET_HOMESALE_INFO_SUCCESS = 'GET_HOMESALE_INFO_SUCCESS';

export const POST_HOMESALE_INFO_FAILURE = 'POST_HOMESALE_INFO_FAILURE';
export const POST_HOMESALE_INFO_REQUEST = 'POST_HOMESALE_INFO_REQUEST';
export const POST_HOMESALE_INFO_SUCCESS = 'POST_HOMESALE_INFO_SUCCESS';

export const UPDATE_HOMESALE_INFO_FAILURE = 'UPDATE_HOMESALE_INFO_FAILURE';
export const UPDATE_HOMESALE_INFO_REQUEST = 'UPDATE_HOMESALE_INFO_REQUEST';
export const UPDATE_HOMESALE_INFO_SUCCESS = 'UPDATE_HOMESALE_INFO_SUCCESS';

export const GET_FAMILY_FAILURE = 'GET_FAMILY_FAILURE';
export const GET_FAMILY_REQUEST = 'GET_FAMILY_REQUEST';
export const GET_FAMILY_SUCCESS = 'GET_FAMILY_SUCCESS';

export const POST_FAMILY_FAILURE = 'POST_FAMILY_FAILURE';
export const POST_FAMILY_REQUEST = 'POST_FAMILY_REQUEST';
export const POST_FAMILY_SUCCESS = 'POST_FAMILY_SUCCESS';

export const UPDATE_FAMILY_FAILURE = 'UPDATE_FAMILY_FAILURE';
export const UPDATE_FAMILY_REQUEST = 'UPDATE_FAMILY_REQUEST';
export const UPDATE_FAMILY_SUCCESS = 'UPDATE_FAMILY_SUCCESS';

export const DELETE_FAMILY_FAILURE = 'DELETE_FAMILY_FAILURE';
export const DELETE_FAMILY_REQUEST = 'DELETE_FAMILY_REQUEST';
export const DELETE_FAMILY_SUCCESS = 'DELETE_FAMILY_SUCCESS';

export const UPDATE_FAMILY_DATA = 'UPDATE_FAMILY_DATA';

export const GET_FAMILY_PET_FAILURE = 'GET_FAMILY_PET_FAILURE';
export const GET_FAMILY_PET_REQUEST = 'GET_FAMILY_PET_REQUEST';
export const GET_FAMILY_PET_SUCCESS = 'GET_FAMILY_PET_SUCCESS';

export const POST_FAMILY_PET_FAILURE = 'POST_FAMILY_PET_FAILURE';
export const POST_FAMILY_PET_REQUEST = 'POST_FAMILY_PET_REQUEST';
export const POST_FAMILY_PET_SUCCESS = 'POST_FAMILY_PET_SUCCESS';

export const UPDATE_FAMILY_PET_FAILURE = 'UPDATE_FAMILY_PET_FAILURE';
export const UPDATE_FAMILY_PET_REQUEST = 'UPDATE_FAMILY_PET_REQUEST';
export const UPDATE_FAMILY_PET_SUCCESS = 'UPDATE_FAMILY_PET_SUCCESS';

export const DELETE_FAMILY_PET_FAILURE = 'DELETE_FAMILY_PET_FAILURE';
export const DELETE_FAMILY_PET_REQUEST = 'DELETE_FAMILY_PET_REQUEST';
export const DELETE_FAMILY_PET_SUCCESS = 'DELETE_FAMILY_PET_SUCCESS';

export const UPDATE_FAMILY_PET_DATA = 'UPDATE_FAMILY_PET_DATA';

export const GET_ALL_GLOBAL_HOME_SERVICE_PROPERTY_FAILURE = 'GET_ALL_GLOBAL_HOME_SERVICE_PROPERTY_FAILURE';
export const GET_ALL_GLOBAL_HOME_SERVICE_PROPERTY_REQUEST = 'GET_ALL_GLOBAL_HOME_SERVICE_PROPERTY_REQUEST';
export const GET_ALL_GLOBAL_HOME_SERVICE_PROPERTY_SUCCESS = 'GET_ALL_GLOBAL_HOME_SERVICE_PROPERTY_SUCCESS';

export const GET_GLOBAL_HOME_SERVICE_PROPERTY_FAILURE = 'GET_GLOBAL_HOME_SERVICE_PROPERTY_FAILURE';
export const GET_GLOBAL_HOME_SERVICE_PROPERTY_REQUEST = 'GET_GLOBAL_HOME_SERVICE_PROPERTY_REQUEST';
export const GET_GLOBAL_HOME_SERVICE_PROPERTY_SUCCESS = 'GET_GLOBAL_HOME_SERVICE_PROPERTY_SUCCESS';

export const POST_GLOBAL_HOME_SERVICE_PROPERTY_FAILURE = 'POST_GLOBAL_HOME_SERVICE_PROPERTY_FAILURE';
export const POST_GLOBAL_HOME_SERVICE_PROPERTY_REQUEST = 'POST_GLOBAL_HOME_SERVICE_PROPERTY_REQUEST';
export const POST_GLOBAL_HOME_SERVICE_PROPERTY_SUCCESS = 'POST_GLOBAL_HOME_SERVICE_PROPERTY_SUCCESS';

export const UPDATE_GLOBAL_HOME_SERVICE_PROPERTY_FAILURE = 'UPDATE_GLOBAL_HOME_SERVICE_PROPERTY_FAILURE';
export const UPDATE_GLOBAL_HOME_SERVICE_PROPERTY_REQUEST = 'UPDATE_GLOBAL_HOME_SERVICE_PROPERTY_REQUEST';
export const UPDATE_GLOBAL_HOME_SERVICE_PROPERTY_SUCCESS = 'UPDATE_GLOBAL_HOME_SERVICE_PROPERTY_SUCCESS';

export const DELETE_GLOBAL_HOME_SERVICE_PROPERTY_FAILURE = 'DELETE_GLOBAL_HOME_SERVICE_PROPERTY_FAILURE';
export const DELETE_GLOBAL_HOME_SERVICE_PROPERTY_REQUEST = 'DELETE_GLOBAL_HOME_SERVICE_PROPERTY_REQUEST';
export const DELETE_GLOBAL_HOME_SERVICE_PROPERTY_SUCCESS = 'DELETE_GLOBAL_HOME_SERVICE_PROPERTY_SUCCESS';

export const GET_ALL_GLOBAL_HOME_SERVICE_PROPERTY_TENANTS_FAILURE = 'GET_ALL_GLOBAL_HOME_SERVICE_PROPERTY_TENANTS_FAILURE';
export const GET_ALL_GLOBAL_HOME_SERVICE_PROPERTY_TENANTS_REQUEST = 'GET_ALL_GLOBAL_HOME_SERVICE_PROPERTY_TENANTS_REQUEST';
export const GET_ALL_GLOBAL_HOME_SERVICE_PROPERTY_TENANTS_SUCCESS = 'GET_ALL_GLOBAL_HOME_SERVICE_PROPERTY_TENANTS_SUCCESS';

export const GET_GLOBAL_HOME_SERVICE_PROPERTY_TENANT_FAILURE = 'GET_GLOBAL_HOME_SERVICE_PROPERTY_TENANT_FAILURE';
export const GET_GLOBAL_HOME_SERVICE_PROPERTY_TENANT_REQUEST = 'GET_GLOBAL_HOME_SERVICE_PROPERTY_TENANT_REQUEST';
export const GET_GLOBAL_HOME_SERVICE_PROPERTY_TENANT_SUCCESS = 'GET_GLOBAL_HOME_SERVICE_PROPERTY_TENANT_SUCCESS';

export const POST_GLOBAL_HOME_SERVICE_PROPERTY_TENANT_FAILURE = 'POST_GLOBAL_HOME_SERVICE_PROPERTY_TENANT_FAILURE';
export const POST_GLOBAL_HOME_SERVICE_PROPERTY_TENANT_REQUEST = 'POST_GLOBAL_HOME_SERVICE_PROPERTY_TENANT_REQUEST';
export const POST_GLOBAL_HOME_SERVICE_PROPERTY_TENANT_SUCCESS = 'POST_GLOBAL_HOME_SERVICE_PROPERTY_TENANT_SUCCESS';

export const UPDATE_GLOBAL_HOME_SERVICE_PROPERTY_TENANT_FAILURE = 'UPDATE_GLOBAL_HOME_SERVICE_PROPERTY_TENANT_FAILURE';
export const UPDATE_GLOBAL_HOME_SERVICE_PROPERTY_TENANT_REQUEST = 'UPDATE_GLOBAL_HOME_SERVICE_PROPERTY_TENANT_REQUEST';
export const UPDATE_GLOBAL_HOME_SERVICE_PROPERTY_TENANT_SUCCESS = 'UPDATE_GLOBAL_HOME_SERVICE_PROPERTY_TENANT_SUCCESS';

export const DELETE_GLOBAL_HOME_SERVICE_PROPERTY_TENANT_FAILURE = 'DELETE_GLOBAL_HOME_SERVICE_PROPERTY_TENANT_FAILURE';
export const DELETE_GLOBAL_HOME_SERVICE_PROPERTY_TENANT_REQUEST = 'DELETE_GLOBAL_HOME_SERVICE_PROPERTY_TENANT_REQUEST';
export const DELETE_GLOBAL_HOME_SERVICE_PROPERTY_TENANT_SUCCESS = 'DELETE_GLOBAL_HOME_SERVICE_PROPERTY_TENANT_SUCCESS';

export const GET_APPRAISALS_FAILURE = 'GET_APPRAISALS_FAILURE';
export const GET_APPRAISALS_REQUEST = 'GET_APPRAISALS_REQUEST';
export const GET_APPRAISALS_SUCCESS = 'GET_APPRAISALS_SUCCESS';

export const POST_APPRAISALS_FAILURE = 'POST_APPRAISALS_FAILURE';
export const POST_APPRAISALS_REQUEST = 'POST_APPRAISALS_REQUEST';
export const POST_APPRAISALS_SUCCESS = 'POST_APPRAISALS_SUCCESS';

export const UPDATE_APPRAISALS_FAILURE = 'UPDATE_APPRAISALS_FAILURE';
export const UPDATE_APPRAISALS_REQUEST = 'UPDATE_APPRAISALS_REQUEST';
export const UPDATE_APPRAISALS_SUCCESS = 'UPDATE_APPRAISALS_SUCCESS';

export const GET_INSPECTORS_FAILURE = 'GET_INSPECTOR_FAILURE';
export const GET_INSPECTORS_REQUEST = 'GET_INSPECTOR_REQUEST';
export const GET_INSPECTORS_SUCCESS = 'GET_INSPECTOR_SUCCESS';

export const POST_INSPECTORS_FAILURE = 'POST_INSPECTOR_FAILURE';
export const POST_INSPECTORS_REQUEST = 'POST_INSPECTOR_REQUEST';
export const POST_INSPECTORS_SUCCESS = 'POST_INSPECTOR_SUCCESS';

export const UPDATE_INSPECTORS_FAILURE = 'UPDATE_INSPECTOR_FAILURE';
export const UPDATE_INSPECTORS_REQUEST = 'UPDATE_INSPECTOR_REQUEST';
export const UPDATE_INSPECTORS_SUCCESS = 'UPDATE_INSPECTOR_SUCCESS';

export const DELETE_INSPECTORS_FAILURE = 'DELETE_INSPECTOR_FAILURE';
export const DELETE_INSPECTORS_REQUEST = 'DELETE_INSPECTOR_REQUEST';
export const DELETE_INSPECTORS_SUCCESS = 'DELETE_INSPECTOR_SUCCESS';

export const GET_INSPECTIONS_FAILURE = 'GET_INSPECTIONS_FAILURE';
export const GET_INSPECTIONS_REQUEST = 'GET_INSPECTIONS_REQUEST';
export const GET_INSPECTIONS_SUCCESS = 'GET_INSPECTIONS_SUCCESS';

export const POST_INSPECTIONS_FAILURE = 'POST_INSPECTIONS_FAILURE';
export const POST_INSPECTIONS_REQUEST = 'POST_INSPECTIONS_REQUEST';
export const POST_INSPECTIONS_SUCCESS = 'POST_INSPECTIONS_SUCCESS';

export const UPDATE_INSPECTIONS_FAILURE = 'UPDATE_INSPECTIONS_FAILURE';
export const UPDATE_INSPECTIONS_REQUEST = 'UPDATE_INSPECTIONS_REQUEST';
export const UPDATE_INSPECTIONS_SUCCESS = 'UPDATE_INSPECTIONS_SUCCESS';

export const DELETE_INSPECTIONS_FAILURE = 'DELETE_INSPECTIONS_FAILURE';
export const DELETE_INSPECTIONS_REQUEST = 'DELETE_INSPECTIONS_REQUEST';
export const DELETE_INSPECTIONS_SUCCESS = 'DELETE_INSPECTIONS_SUCCESS';

export const UPDATE_INSPECTIONS_STATE = 'UPDATE_INSPECTIONS_STATE';

export const GET_LISTINGS_FAILURE = 'GET_LISTINGS_FAILURE';
export const GET_LISTINGS_REQUEST = 'GET_LISTINGS_REQUEST';
export const GET_LISTINGS_SUCCESS = 'GET_LISTINGS_SUCCESS';

export const POST_LISTINGS_FAILURE = 'POST_LISTINGS_FAILURE';
export const POST_LISTINGS_REQUEST = 'POST_LISTINGS_REQUEST';
export const POST_LISTINGS_SUCCESS = 'POST_LISTINGS_SUCCESS';

export const UPDATE_LISTINGS_FAILURE = 'UPDATE_LISTINGS_FAILURE';
export const UPDATE_LISTINGS_REQUEST = 'UPDATE_LISTINGS_REQUEST';
export const UPDATE_LISTINGS_SUCCESS = 'UPDATE_LISTINGS_SUCCESS';

export const GET_TITLE_REP_FAILURE = 'GET_TITLE_REP_FAILURE';
export const GET_TITLE_REP_REQUEST = 'GET_TITLE_REP_REQUEST';
export const GET_TITLE_REP_SUCCESS = 'GET_TITLE_REP_SUCCESS';

export const POST_TITLE_REP_FAILURE = 'POST_TITLE_REP_FAILURE';
export const POST_TITLE_REP_REQUEST = 'POST_TITLE_REP_REQUEST';
export const POST_TITLE_REP_SUCCESS = 'POST_TITLE_REP_SUCCESS';

export const UPDATE_TITLE_REP_FAILURE = 'UPDATE_TITLE_REP_FAILURE';
export const UPDATE_TITLE_REP_REQUEST = 'UPDATE_TITLE_REP_REQUEST';
export const UPDATE_TITLE_REP_SUCCESS = 'UPDATE_TITLE_REP_SUCCESS';

export const DELETE_TITLE_REP_FAILURE = 'DELETE_TITLE_REP_FAILURE';
export const DELETE_TITLE_REP_REQUEST = 'DELETE_TITLE_REP_REQUEST';
export const DELETE_TITLE_REP_SUCCESS = 'DELETE_TITLE_REP_SUCCESS';

export const GET_ALL_HOMESALE_RESALE_OFFER_FAILURE = 'GET_ALL_HOMESALE_RESALE_OFFER_FAILURE';
export const GET_ALL_HOMESALE_RESALE_OFFER_REQUEST = 'GET_ALL_HOMESALE_RESALE_OFFER_REQUEST';
export const GET_ALL_HOMESALE_RESALE_OFFER_SUCCESS = 'GET_ALL_HOMESALE_RESALE_OFFER_SUCCESS';

export const GET_HOMESALE_RESALE_OFFER_FAILURE = 'GET_HOMESALE_RESALE_OFFER_FAILURE';
export const GET_HOMESALE_RESALE_OFFER_REQUEST = 'GET_HOMESALE_RESALE_OFFER_REQUEST';
export const GET_HOMESALE_RESALE_OFFER_SUCCESS = 'GET_HOMESALE_RESALE_OFFER_SUCCESS';

export const POST_HOMESALE_RESALE_OFFER_FAILURE = 'POST_HOMESALE_RESALE_OFFER_FAILURE';
export const POST_HOMESALE_RESALE_OFFER_REQUEST = 'POST_HOMESALE_RESALE_OFFER_REQUEST';
export const POST_HOMESALE_RESALE_OFFER_SUCCESS = 'POST_HOMESALE_RESALE_OFFER_SUCCESS';

export const UPDATE_HOMESALE_RESALE_OFFER_FAILURE = 'UPDATE_HOMESALE_RESALE_OFFER_FAILURE';
export const UPDATE_HOMESALE_RESALE_OFFER_REQUEST = 'UPDATE_HOMESALE_RESALE_OFFER_REQUEST';
export const UPDATE_HOMESALE_RESALE_OFFER_SUCCESS = 'UPDATE_HOMESALE_RESALE_OFFER_SUCCESS';

export const DELETE_HOMESALE_RESALE_OFFER_FAILURE = 'DELETE_HOMESALE_RESALE_OFFER_FAILURE';
export const DELETE_HOMESALE_RESALE_OFFER_REQUEST = 'DELETE_HOMESALE_RESALE_OFFER_REQUEST';
export const DELETE_HOMESALE_RESALE_OFFER_SUCCESS = 'DELETE_HOMESALE_RESALE_OFFER_SUCCESS';

export const GET_EQUITY_FAILURE = 'GET_EQUITY_FAILURE';
export const GET_EQUITY_REQUEST = 'GET_EQUITY_REQUEST';
export const GET_EQUITY_SUCCESS = 'GET_EQUITY_SUCCESS';

export const POST_EQUITY_FAILURE = 'POST_EQUITY_FAILURE';
export const POST_EQUITY_REQUEST = 'POST_EQUITY_REQUEST';
export const POST_EQUITY_SUCCESS = 'POST_EQUITY_SUCCESS';

export const UPDATE_EQUITY_FAILURE = 'UPDATE_EQUITY_FAILURE';
export const UPDATE_EQUITY_REQUEST = 'UPDATE_EQUITY_REQUEST';
export const UPDATE_EQUITY_SUCCESS = 'UPDATE_EQUITY_SUCCESS';

export const GET_TAX_FAILURE = 'GET_TAX_FAILURE';
export const GET_TAX_REQUEST = 'GET_TAX_REQUEST';
export const GET_TAX_SUCCESS = 'GET_TAX_SUCCESS';

export const POST_TAX_FAILURE = 'POST_TAX_FAILURE';
export const POST_TAX_REQUEST = 'POST_TAX_REQUEST';
export const POST_TAX_SUCCESS = 'POST_TAX_SUCCESS';

export const UPDATE_TAX_FAILURE = 'UPDATE_TAX_FAILURE';
export const UPDATE_TAX_REQUEST = 'UPDATE_TAX_REQUEST';
export const UPDATE_TAX_SUCCESS = 'UPDATE_TAX_SUCCESS';

export const DELETE_TAX_FAILURE = 'DELETE_TAX_FAILURE';
export const DELETE_TAX_REQUEST = 'DELETE_TAX_REQUEST';
export const DELETE_TAX_SUCCESS = 'DELETE_TAX_SUCCESS';

export const GET_CREDIT_FAILURE = 'GET_CREDIT_FAILURE';
export const GET_CREDIT_REQUEST = 'GET_CREDIT_REQUEST';
export const GET_CREDIT_SUCCESS = 'GET_CREDIT_SUCCESS';

export const POST_CREDIT_FAILURE = 'POST_CREDIT_FAILURE';
export const POST_CREDIT_REQUEST = 'POST_CREDIT_REQUEST';
export const POST_CREDIT_SUCCESS = 'POST_CREDIT_SUCCESS';

export const UPDATE_CREDIT_FAILURE = 'UPDATE_CREDIT_FAILURE';
export const UPDATE_CREDIT_REQUEST = 'UPDATE_CREDIT_REQUEST';
export const UPDATE_CREDIT_SUCCESS = 'UPDATE_CREDIT_SUCCESS';

export const DELETE_CREDIT_FAILURE = 'DELETE_CREDIT_FAILURE';
export const DELETE_CREDIT_REQUEST = 'DELETE_CREDIT_REQUEST';
export const DELETE_CREDIT_SUCCESS = 'DELETE_CREDIT_SUCCESS';

export const GET_EXPENSE_CODES_FAILURE = 'GET_EXPENSE_CODES_FAILURE';
export const GET_EXPENSE_CODES_REQUEST = 'GET_EXPENSE_CODES_REQUEST';
export const GET_EXPENSE_CODES_SUCCESS = 'GET_EXPENSE_CODES_SUCCESS';

export const POST_EXPENSE_CODES_FAILURE = 'POST_EXPENSE_CODES_FAILURE';
export const POST_EXPENSE_CODES_REQUEST = 'POST_EXPENSE_CODES_REQUEST';
export const POST_EXPENSE_CODES_SUCCESS = 'POST_EXPENSE_CODES_SUCCESS';

export const UPDATE_EXPENSE_CODES_FAILURE = 'UPDATE_EXPENSE_CODES_FAILURE';
export const UPDATE_EXPENSE_CODES_REQUEST = 'UPDATE_EXPENSE_CODES_REQUEST';
export const UPDATE_EXPENSE_CODES_SUCCESS = 'UPDATE_EXPENSE_CODES_SUCCESS';

export const DELETE_EXPENSE_CODES_FAILURE = 'DELETE_EXPENSE_CODES_FAILURE';
export const DELETE_EXPENSE_CODES_REQUEST = 'DELETE_EXPENSE_CODES_REQUEST';
export const DELETE_EXPENSE_CODES_SUCCESS = 'DELETE_EXPENSE_CODES_SUCCESS';

export const DELETE_EQUITY_FAILURE = 'DELETE_EQUITY_FAILURE';
export const DELETE_EQUITY_REQUEST = 'DELETE_EQUITY_REQUEST';
export const DELETE_EQUITY_SUCCESS = 'DELETE_EQUITY_SUCCESS';


export const GET_CANDIDATE_SERVICES_FAILURE = 'GET_CANDIDATE_SERVICES_FAILURE';
export const GET_CANDIDATE_SERVICES_REQUEST = 'GET_CANDIDATE_SERVICES_REQUEST';
export const GET_CANDIDATE_SERVICES_SUCCESS = 'GET_CANDIDATE_SERVICES_SUCCESS';

export const POST_CANDIDATE_SERVICES_FAILURE = 'POST_CANDIDATE_SERVICES_FAILURE';
export const POST_CANDIDATE_SERVICES_REQUEST = 'POST_CANDIDATE_SERVICES_REQUEST';
export const POST_CANDIDATE_SERVICES_SUCCESS = 'POST_CANDIDATE_SERVICES_SUCCESS';

export const UPDATE_CANDIDATE_SERVICES_FAILURE = 'UPDATE_CANDIDATE_SERVICES_FAILURE';
export const UPDATE_CANDIDATE_SERVICES_REQUEST = 'UPDATE_CANDIDATE_SERVICES_REQUEST';
export const UPDATE_CANDIDATE_SERVICES_SUCCESS = 'UPDATE_CANDIDATE_SERVICES_SUCCESS';

export const GET_INTERN_SERVICES_FAILURE = 'GET_INTERN_SERVICES_FAILURE';
export const GET_INTERN_SERVICES_REQUEST = 'GET_INTERN_SERVICES_REQUEST';
export const GET_INTERN_SERVICES_SUCCESS = 'GET_INTERN_SERVICES_SUCCESS';

export const POST_INTERN_SERVICES_FAILURE = 'POST_INTERN_SERVICES_FAILURE';
export const POST_INTERN_SERVICES_REQUEST = 'POST_INTERN_SERVICES_REQUEST';
export const POST_INTERN_SERVICES_SUCCESS = 'POST_INTERN_SERVICES_SUCCESS';

export const UPDATE_INTERN_SERVICES_FAILURE = 'UPDATE_INTERN_SERVICES_FAILURE';
export const UPDATE_INTERN_SERVICES_REQUEST = 'UPDATE_INTERN_SERVICES_REQUEST';
export const UPDATE_INTERN_SERVICES_SUCCESS = 'UPDATE_INTERN_SERVICES_SUCCESS';

export const GET_ALL_CANDIDATE_TRIPS_FAILURE = 'GET_ALL_CANDIDATE_TRIPS_FAILURE';
export const GET_ALL_CANDIDATE_TRIPS_REQUEST = 'GET_ALL_CANDIDATE_TRIPS_REQUEST';
export const GET_ALL_CANDIDATE_TRIPS_SUCCESS = 'GET_ALL_CANDIDATE_TRIPS_SUCCESS';

export const GET_CANDIDATE_TRIP_FAILURE = 'GET_CANDIDATE_TRIP_FAILURE';
export const GET_CANDIDATE_TRIP_REQUEST = 'GET_CANDIDATE_TRIP_REQUEST';
export const GET_CANDIDATE_TRIP_SUCCESS = 'GET_CANDIDATE_TRIP_SUCCESS';

export const UPSERT_CANDIDATE_TRIP_FAILURE = 'UPSERT_CANDIDATE_TRIP_FAILURE';
export const UPSERT_CANDIDATE_TRIP_REQUEST = 'UPSERT_CANDIDATE_TRIP_REQUEST';
export const UPSERT_CANDIDATE_TRIP_SUCCESS = 'UPSERT_CANDIDATE_TRIP_SUCCESS';

export const DELETE_CANDIDATE_TRIP_FAILURE = 'DELETE_CANDIDATE_TRIP_FAILURE';
export const DELETE_CANDIDATE_TRIP_REQUEST = 'DELETE_CANDIDATE_TRIP_REQUEST';
export const DELETE_CANDIDATE_TRIP_SUCCESS = 'DELETE_CANDIDATE_TRIP_SUCCESS';

export const GET_COST_ESTIMATES_FAILURE = 'GET_COST_ESTIMATES_FAILURE';
export const GET_COST_ESTIMATES_REQUEST = 'GET_COST_ESTIMATES_REQUEST';
export const GET_COST_ESTIMATES_SUCCESS = 'GET_COST_ESTIMATES_SUCCESS';

export const POST_COST_ESTIMATES_FAILURE = 'POST_COST_ESTIMATES_FAILURE';
export const POST_COST_ESTIMATES_REQUEST = 'POST_COST_ESTIMATES_REQUEST';
export const POST_COST_ESTIMATES_SUCCESS = 'POST_COST_ESTIMATES_SUCCESS';

export const UPDATE_COST_ESTIMATES_FAILURE = 'UPDATE_COST_ESTIMATES_FAILURE';
export const UPDATE_COST_ESTIMATES_REQUEST = 'UPDATE_COST_ESTIMATES_REQUEST';
export const UPDATE_COST_ESTIMATES_SUCCESS = 'UPDATE_COST_ESTIMATES_SUCCESS';

export const GET_ALL_BUYER_TRIPS_FAILURE = 'GET_ALL_BUYER_TRIPS_FAILURE';
export const GET_ALL_BUYER_TRIPS_REQUEST = 'GET_ALL_BUYER_TRIPS_REQUEST';
export const GET_ALL_BUYER_TRIPS_SUCCESS = 'GET_ALL_BUYER_TRIPS_SUCCESS';

export const GET_BUYER_TRIP_FAILURE = 'GET_BUYER_TRIP_FAILURE';
export const GET_BUYER_TRIP_REQUEST = 'GET_BUYER_TRIP_REQUEST';
export const GET_BUYER_TRIP_SUCCESS = 'GET_BUYER_TRIP_SUCCESS';

export const UPSERT_BUYER_TRIP_FAILURE = 'UPSERT_BUYER_TRIP_FAILURE';
export const UPSERT_BUYER_TRIP_REQUEST = 'UPSERT_BUYER_TRIP_REQUEST';
export const UPSERT_BUYER_TRIP_SUCCESS = 'UPSERT_BUYER_TRIP_SUCCESS';

export const DELETE_BUYER_TRIP_FAILURE = 'DELETE_BUYER_TRIP_FAILURE';
export const DELETE_BUYER_TRIP_REQUEST = 'DELETE_BUYER_TRIP_REQUEST';
export const DELETE_BUYER_TRIP_SUCCESS = 'DELETE_BUYER_TRIP_SUCCESS';

export const GET_ALL_RENTER_TRIPS_FAILURE = 'GET_ALL_RENTER_TRIPS_FAILURE';
export const GET_ALL_RENTER_TRIPS_REQUEST = 'GET_ALL_RENTER_TRIPS_REQUEST';
export const GET_ALL_RENTER_TRIPS_SUCCESS = 'GET_ALL_RENTER_TRIPS_SUCCESS';

export const GET_RENTER_TRIP_FAILURE = 'GET_RENTER_TRIP_FAILURE';
export const GET_RENTER_TRIP_REQUEST = 'GET_RENTER_TRIP_REQUEST';
export const GET_RENTER_TRIP_SUCCESS = 'GET_RENTER_TRIP_SUCCESS';

export const UPSERT_RENTER_TRIP_FAILURE = 'UPSERT_RENTER_TRIP_FAILURE';
export const UPSERT_RENTER_TRIP_REQUEST = 'UPSERT_RENTER_TRIP_REQUEST';
export const UPSERT_RENTER_TRIP_SUCCESS = 'UPSERT_RENTER_TRIP_SUCCESS';

export const DELETE_RENTER_TRIP_FAILURE = 'DELETE_RENTER_TRIP_FAILURE';
export const DELETE_RENTER_TRIP_REQUEST = 'DELETE_RENTER_TRIP_REQUEST';
export const DELETE_RENTER_TRIP_SUCCESS = 'DELETE_RENTER_TRIP_SUCCESS';

export const GET_ALL_TEMP_LIVING_TRIPS_FAILURE = 'GET_ALL_TEMP_LIVING_TRIPS_FAILURE';
export const GET_ALL_TEMP_LIVING_TRIPS_REQUEST = 'GET_ALL_TEMP_LIVING_TRIPS_REQUEST';
export const GET_ALL_TEMP_LIVING_TRIPS_SUCCESS = 'GET_ALL_TEMP_LIVING_TRIPS_SUCCESS';

export const GET_TEMP_LIVING_TRIP_FAILURE = 'GET_TEMP_LIVING_TRIP_FAILURE';
export const GET_TEMP_LIVING_TRIP_REQUEST = 'GET_TEMP_LIVING_TRIP_REQUEST';
export const GET_TEMP_LIVING_TRIP_SUCCESS = 'GET_TEMP_LIVING_TRIP_SUCCESS';

export const UPSERT_TEMP_LIVING_TRIP_FAILURE = 'UPSERT_TEMP_LIVING_TRIP_FAILURE';
export const UPSERT_TEMP_LIVING_TRIP_REQUEST = 'UPSERT_TEMP_LIVING_TRIP_REQUEST';
export const UPSERT_TEMP_LIVING_TRIP_SUCCESS = 'UPSERT_TEMP_LIVING_TRIP_SUCCESS';

export const DELETE_TEMP_LIVING_TRIP_FAILURE = 'DELETE_TEMP_LIVING_TRIP_FAILURE';
export const DELETE_TEMP_LIVING_TRIP_REQUEST = 'DELETE_TEMP_LIVING_TRIP_REQUEST';
export const DELETE_TEMP_LIVING_TRIP_SUCCESS = 'DELETE_TEMP_LIVING_TRIP_SUCCESS';

export const POST_GLOBAL_ASSIGNMENT_REQUEST = 'POST_GLOBAL_ASSIGNMENT_REQUEST';
export const POST_GLOBAL_ASSIGNMENT_FAILURE = 'POST_GLOBAL_ASSIGNMENT_FAILURE';
export const POST_GLOBAL_ASSIGNMENT_SUCCESS = 'POST_GLOBAL_ASSIGNMENT_SUCCESS';

export const UPDATE_GLOBAL_ASSIGNMENT_REQUEST = 'UPDATE_GLOBAL_ASSIGNMENT_REQUEST';
export const UPDATE_GLOBAL_ASSIGNMENT_FAILURE = 'UPDATE_GLOBAL_ASSIGNMENT_FAILURE';
export const UPDATE_GLOBAL_ASSIGNMENT_SUCCESS = 'UPDATE_GLOBAL_ASSIGNMENT_SUCCESS';
